import { toast } from "react-toastify";
import "./PtsAlert.css";

const PtsAlert = {
  success(msg, options = {}) {
    return toast.success(
      <div className="toast-content">
        <div className="toast-icon success-icon">✔</div>
        <div className="toast-text">
          <strong>SUCCESS!</strong>
          <div>{msg}</div>
        </div>
      </div>,
      {
        ...options,
        className: "toast-box toast-success",
        closeButton: true,
        icon: false,
      }
    );
  },
  error(msg, options = {}) {
    return toast.error(
      <div className="toast-content">
        <div className="toast-icon error-icon">✖</div>
        <div className="toast-text">
          <strong>ERROR!</strong>
          <div>{msg}</div>
        </div>
      </div>,
      {
        ...options,
        className: "toast-box toast-error",
        closeButton: true,
        icon: false,
      }
    );
  },
  warn(msg, options = {}) {
    return toast.warn(
      <div className="toast-content">
        <div className="toast-icon warn-icon">⚠</div>
        <div className="toast-text">
          <strong>WARNING!</strong>
          <div>{msg}</div>
        </div>
      </div>,
      {
        ...options,
        className: "toast-box toast-warn",
        closeButton: true,
        icon: false,
      }
    );
  },
  info(msg, options = {}) {
    return toast.info(
      <div className="toast-content">
        <div className="toast-icon info-icon">ℹ</div>
        <div className="toast-text">
          <strong>INFO!</strong>
          <div>{msg}</div>
        </div>
      </div>,
      {
        ...options,
        className: "toast-box toast-info",
        closeButton: true,
        icon: false,
      }
    );
  },
};

export default PtsAlert;
